import { Icon } from './Icon'

interface LoadingStateProps {
  message?: string
}

export function LoadingState({ message = 'Loading...' }: LoadingStateProps) {
  return (
    <div className="empty-state">
      <div className="loading-spinner" />
      <p className="mt-4 text-muted">{message}</p>
    </div>
  )
}

interface ErrorStateProps {
  message?: string
  onRetry?: () => void
}

export function ErrorState({
  message = 'Failed to load data',
  onRetry
}: ErrorStateProps) {
  return (
    <div className="empty-state">
      <Icon name="error" size={48} className="text-danger" />
      <p className="mt-4 text-muted">{message}</p>
      {onRetry && (
        <button className="btn btn-primary mt-4" onClick={onRetry}>
          <Icon name="refresh" size={16} />
          Try Again
        </button>
      )}
    </div>
  )
}
